import { ComingSoonHero } from './components/ComingSoonHero'

export function ComingSoonPage() {
  return <ComingSoonHero />
}
